const PRODUCTION_TARGET = 'producao';
const KNOWN_PRODUCTION_PROJECT_REF = 'hjyvpgpoqqqrouktaqlr';

function readProjectRef(url) {
  try {
    const hostname = new URL(url).hostname;
    return hostname.endsWith('.supabase.co') ? hostname.split('.')[0] : '';
  } catch {
    return '';
  }
}

export function readPlotMigrationRuntime(env = process.env) {
  const mainProjectRef = readProjectRef(env.REACT_APP_SUPABASE_URL || '');
  const configuredProjectRef = mainProjectRef;
  const declaredTarget = String(env.REACT_APP_TALHOES_MIGRATION_TARGET || '').trim();
  const expectedProductionProjectRef = String(
    env.REACT_APP_TALHOES_MIGRATION_PRODUCTION_PROJECT_REF || ''
  ).trim();
  const unifiedRuntimeRequested = env.REACT_APP_TALHOES_MIGRATION_UNIFIED === 'true';
  const effectiveTarget = unifiedRuntimeRequested ? PRODUCTION_TARGET : declaredTarget;
  const uiRequested = env.REACT_APP_TALHOES_MIGRATION_UI_ENABLED === 'true';
  const writesRequested = env.REACT_APP_TALHOES_MIGRATION_ENABLE_WRITES === 'true';
  const productionReleaseRequested = env.REACT_APP_TALHOES_MIGRATION_ALLOW_PRODUCTION === 'true';
  const mainIsProductionProject = mainProjectRef === KNOWN_PRODUCTION_PROJECT_REF;
  const productionReleaseConfirmed = mainIsProductionProject
    && unifiedRuntimeRequested
    && effectiveTarget === PRODUCTION_TARGET
    && expectedProductionProjectRef === KNOWN_PRODUCTION_PROJECT_REF
    && productionReleaseRequested;

  return Object.freeze({
    mainProjectRef,
    configuredProjectRef,
    usesDedicatedMigrationProject: false,
    mainIsProductionProject,
    expectedHomologationProjectRef: '',
    declaredTarget: effectiveTarget,
    configuredTarget: declaredTarget,
    unifiedRuntimeRequested,
    isProductionProject: mainIsProductionProject,
    homologationConfirmed: false,
    productionReleaseConfirmed,
    uiEnabled: productionReleaseConfirmed && uiRequested,
    readsEnabled: productionReleaseConfirmed && uiRequested,
    writesEnabled: productionReleaseConfirmed && uiRequested && writesRequested,
    localRealDataRequested: false,
    sharedOwnerEnabled: false,
    safetyReason: mainIsProductionProject && !productionReleaseConfirmed
      ? 'producao_bloqueada'
      : productionReleaseConfirmed
        ? (writesRequested
          ? 'producao_confirmada'
          : 'gravacoes_desligadas')
        : 'producao_nao_confirmada',
  });
}

export function canUseLocalRealMigrationData() {
  return false;
}

export const plotMigrationRuntime = readPlotMigrationRuntime();
